import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

export var bannedUsernameEmails = ["info", "sales", "marketing", "support", "no-reply", "privacy", "webmaster", "admin", "editor", "hello", "contact", "hr", "example"];
var sharedEmailRegex = new RegExp(String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["^(?!.*(?:", ")@)[w-+.]+@([w-]+.)+[w-]{2,}"], ["^(?!.*(?:", ")@)[\\w-+.]+@([\\w-]+\\.)+[\\w-]{2,}"])), bannedUsernameEmails.join("|")), "gi");
export default sharedEmailRegex;